import { render, staticRenderFns } from "./ExerciseV1Mount.vue?vue&type=template&id=9e8007a8"
import script from "./ExerciseV1Mount.vue?vue&type=script&lang=js"
export * from "./ExerciseV1Mount.vue?vue&type=script&lang=js"
import style0 from "./ExerciseV1Mount.vue?vue&type=style&index=0&id=9e8007a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports